// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3Xb_i","box":"WorkspacesBox_box__3C-ga","node":"WorkspacesBox_node__36ond"};